module.exports = __webpack_public_path__ + "images/moonshot/email-verification.00df5cebb19617810582.svg";